import React, { FunctionComponent } from "react";
import { FormSection } from "../../../FormSection";
import { Grid, MenuItem } from "@mui/material";
import { DropdownValue } from "../../../../types/DropdownValue";
import Icon from "@mdi/react";
import { mdiReceiptOutline } from "@mdi/js";
import { SectionProps } from "../props";
import { CustomSelect } from "../../../CustomSelect";
import { CustomAutocomplete } from "../../../CustomAutocomplete";
import { User } from "../../../../model/User";

type AdministrativeInformationState = {
  nbrId: number;
  number: DropdownValue | null;
  nonBillReasonDropdownItems: DropdownValue[];
  dialedTollFreeDropdownItems: DropdownValue[];
};

export const AdministrativeInformation: FunctionComponent<
  AdministrativeInformationState & SectionProps
> = (props) => {
  const user = new User();

  const showNonBillReason = !user.HasForbiddenAccess("Can See Non Bill Reason");
  const showNumber = !user.HasForbiddenAccess("Can See Number");
  const showAdminInfo = showNonBillReason || showNumber;

  const editNonBillReason = !user.HasForbiddenAccess(
    "Can Edit Non Bill Reason"
  );
  const editNumber = !user.HasForbiddenAccess("Can Edit Number");

  return showAdminInfo ? (
    <FormSection title="Administrative Information" isCollapsible>
      {showNonBillReason && (
        <Grid item>
          <CustomSelect
            disabled={props.formDisabled || !editNonBillReason}
            StartIcon={<Icon path={mdiReceiptOutline} />}
            label="Non Bill Reason"
            name="nbrId"
            value={props.nbrId}
            onChange={props.onChangeSelect}
          >
            {props.nonBillReasonDropdownItems.map((item, index) => {
              return (
                <MenuItem key={index} value={item.id}>
                  {item.description}
                </MenuItem>
              );
            })}
          </CustomSelect>
        </Grid>
      )}
      {showNumber && (
        <Grid item>
          <CustomAutocomplete
            width={350}
            disabled={props.formDisabled || !editNumber}
            options={props.dialedTollFreeDropdownItems}
            name="dialedTollFree"
            label={{
              text: "Number",
            }}
            value={props.number}
            onChange={(event, value, name) =>
              props.onChangeAutoComplete &&
              props.onChangeAutoComplete(event, value, name)
            }
          />
        </Grid>
      )}
    </FormSection>
  ) : null;
};
